import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
  details: [],
};

export const getAccounts = createAsyncThunk(
  'campaign/get-accounts',
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/campaign/organization-details/${id}`, {
        search: data,
        type: 'member',
      });
      return response?.data;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });
      return rejectWithValue(error?.response?.data);
    }
  }
);

const getAccountsSlice = createSlice({
  name: 'Get Accounts',
  initialState: initialState,
  reducers: {
    resetAccountDetails: (state) => {
      state.details = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAccounts.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.details = [];
    });
    builder.addCase(getAccounts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action?.payload?.success;
      state.message = action?.payload?.message;
      state.details = action?.payload?.details;
    });
    builder.addCase(getAccounts.rejected, (state, action) => {
      state.isLoading = false;
      state.errors = action.payload?.errors || [];
      state.details = [];
      state.isError = true;
    });
  },
});

export const { resetAccountDetails } = getAccountsSlice.actions;

export default getAccountsSlice?.reducer;
